import { useEffect, useState } from "react";

export function useStock(initial = 47, floor = 6) {
  const [stock, setStock] = useState(initial);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      timer = setTimeout(() => {
        setStock((s) => Math.max(floor, s - (Math.random() < 0.25 ? 2 : 1)));
        schedule();
      }, 6000 + Math.random() * 10000);
    };
    schedule();
    return () => clearTimeout(timer);
  }, [floor]);

  return stock;
}
